/* External */
import { memo, useEffect, useRef } from 'react';

/* Utils */
import { PageType } from '../../../utils/constants';
import { useCountry } from '../../../providers/ConfigProvider';
import { useGtmLocalContext } from '../../../providers/GtmLocalProvider';
import { GTM_CATEGORIES, GTM_EVENT_NAMES, GTM_SUBCATEGORIES } from '../../../utils/googleTags';

/* Components */
import LanderPage from '../../../components/LanderPage';

function OnDemand() {
  const country = useCountry();
  const { commonTaggingEvent } = useGtmLocalContext();
  const tagsMountRef = useRef(true);

  useEffect(() => {
    if (tagsMountRef.current && country) {
      commonTaggingEvent({
        category: GTM_CATEGORIES.LIVE_CATALOG_SPORTS_KIDS_PAGE_DATA,
        subCategory: GTM_SUBCATEGORIES.PAGES.CATALOG_PAGE,
        eventName: GTM_EVENT_NAMES.PAGE_VIEW,
      });
      tagsMountRef.current = false;
    }
  }, [commonTaggingEvent, country]);

  return <LanderPage pageId={PageType.VOD} />;
}

export default memo(OnDemand);
